import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=21adb1c3&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=21adb1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adb1c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21adb1c3')) {
      api.createRecord('21adb1c3', component.options)
    } else {
      api.reload('21adb1c3', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=21adb1c3&scoped=true&", function () {
      api.rerender('21adb1c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aHCHLZ3chW1G/JS/comp/PopupBox.vue"
export default component.exports